// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pilot-warning {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 16px;
  z-index: 4;
  min-height: 50px;
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  min-width: 400px;
}

mat-toolbar {
  background-color: transparent;
  position: absolute;
  top: 50px;
  z-index: 100;
}

@media (max-width: 952px) {
  mat-toolbar {
    top: 64px;
  }
}
@media (max-width: 521px) {
  mat-toolbar {
    top: 88px;
  }
}
a, a:hover, a:focus {
  color: inherit;
  text-decoration: none;
  transition: all 0.3s;
}

.navbar-container {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.brand img {
  height: 30px;
}

img {
  vertical-align: middle;
}

.flex-spacer {
  flex-grow: 1;
}`, "",{"version":3,"sources":["webpack://./src/app/nonAdmin/navbar/navbar.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,gBAAA;AACJ;;AAGC;EACI,6BAAA;EACA,kBAAA;EAEA,SAAA;EACA,YAAA;AADL;;AAKI;EACI;IACI,SAAA;EAFV;AACF;AAOI;EACI;IACI,SAAA;EALV;AACF;AASA;EACI,cAAA;EACA,qBAAA;EACA,oBAAA;AAPJ;;AAUA;EACI,aAAA;EACA,eAAA;EACA,mBAAA;AAPJ;;AAUA;EACI,YAAA;AAPJ;;AAUA;EACI,sBAAA;AAPJ;;AAUA;EACI,YAAA;AAPJ","sourcesContent":[".pilot-warning{\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    padding: 8px 16px;\r\n    z-index: 4;\r\n    min-height: 50px;\r\n    position: absolute;\r\n    top: 0;\r\n    right: 0;\r\n    left: 0;\r\n    min-width: 400px;\r\n }\r\n\r\n \r\n mat-toolbar { \r\n     background-color: transparent;\r\n     position: absolute;\r\n     //top: 0px;\r\n     top: 50px;\r\n     z-index: 100;\r\n    }\r\n\r\n    //To be deleted after pilot\r\n    @media (max-width:952px) {\r\n        mat-toolbar {\r\n            top: 64px\r\n        }\r\n    }\r\n    //\r\n    \r\n    //To be deleted after pilot\r\n    @media (max-width:521px) {\r\n        mat-toolbar {\r\n            top: 88px\r\n        }\r\n    }\r\n    //\r\n\r\na, a:hover, a:focus {\r\n    color: inherit;\r\n    text-decoration: none;\r\n    transition: all 0.3s;\r\n}\r\n\r\n.navbar-container {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    align-items: center\r\n}\r\n\r\n.brand img {\r\n    height: 30px;\r\n}\r\n\r\nimg {\r\n    vertical-align: middle\r\n}\r\n\r\n.flex-spacer {\r\n    flex-grow: 1;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
